import axios from 'axios';

export const instance = axios.create({
  baseURL: 'https://api.sourcer.com/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});
